// extracted by mini-css-extract-plugin
module.exports = {"order-details__status":"status_order-details__status__WvLMa","active":"status_active__eCNQk","dotted":"status_dotted__QgPii"};